import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import P from "../../components/typography/P"
import { fontBold } from "../../utils/fontFamily"
import darkArrow from "../../images/icons/dark-arrow.svg"
import Container from "./Container"
import Section from "./Section"
import { useTheme } from "../../context/ThemeContext"
import { StandardPlanName } from "../../utils/enumUtil"

const StripWrapper = styled(Section)`
  background: linear-gradient(269.93deg, #8cca6d -3.63%, #57ac2d 50.09%);
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    text-decoration: none;
  }

  ${({ theme }) => theme.se`
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 30px;
  `}

  ${({ theme }) => theme.tablet`
    flex-direction: row;
    height: 150px;
    align-items: center;
  `}
`

const OfferText = styled(P)`
  font-weight: bold;
  font-size: 30px;
  color: #fff;

  ${({ theme }) => theme.se`
   font-size: 20px;
  `}

  ${({ theme }) => theme.tablet`
   font-size: 20px;
  `}

  ${({ theme }) => theme.desktop`
      font-size: 22px;
      margin-bottom: 0;
  `}

  ${({ theme }) => theme.largeDesktop`
      font-size: 26px;
  `}
`

const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fcfcfc;
  border: 1px solid #c4c4c4;
  color: #555;
  ${fontBold()}
  border-radius: 50px;
  min-width: 200px;
  padding: 10px 30px;
  cursor: pointer;

  img {
    margin-bottom: 0;
  }
`

const CustomContainer = styled(Container)`
  margin-right: auto;
  margin-left: auto;
  align-items: center;

  a {
    cursor: pointer;
  }
  ${({ theme }) => theme.tablet`
      justify-content: center;
  `}

  ${({ theme }) => theme.desktop`
      justify-content: space-between;
  `}
`

const CallToActionStrip = ({ customText, link, buttonText, internal }) => {
  const themeToggle = useTheme()
  const onTrialClick = () => {
    themeToggle.saveTrialPlan(StandardPlanName.Premium)
  }
  return (
    <StripWrapper>
      <CustomContainer>
        <OfferText>{customText}</OfferText>
        {link ? (
          internal ? (
            <Link to={link}>
              <Button>
                {buttonText}
                <img src={darkArrow} />
              </Button>
            </Link>
          ) : (
            <a href={link} target="_blank">
              <Button>
                {buttonText}
                <img src={darkArrow} />
              </Button>
            </a>
          )
        ) : (
          <Button onClick={() => onTrialClick()}>
            {buttonText}
            <img src={darkArrow} />
          </Button>
        )}
      </CustomContainer>
    </StripWrapper>
  )
}

CallToActionStrip.propTypes = {
  link: PropTypes.string,
  customText: PropTypes.string,
  buttonText: PropTypes.string,
  internal: PropTypes.bool,
  onClick: PropTypes.func,
}

CallToActionStrip.defaultProps = {
  link: "",
  customText: "Market like the pros. Try now with no credit card required.",
  buttonText: "Free Trial",
  internal: false,
  onClick: () => {},
}

export default CallToActionStrip
